import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

export default function TruncatedPill({ children, className }) {
  return (
    <span className={classNames('truncated-pill', 'tw-mr-2', className)}>
      <span className='truncated-text-container'>{children}</span>
    </span>
  );
}

TruncatedPill.propTypes = {
  className: PropTypes.string,
};
